import {Box, Paper, Typography} from '@mui/material';
import MarkdownContentRenderer from '../MarkdownContentRenderer/MarkdownContentRenderer';

export interface RenderedHintProps {
  hint: string;
}

export default function RenderedHint({hint}: RenderedHintProps) {
  return (
    <Box>
      <Typography variant="body2" color="text.secondary" sx={{mb: 1, fontWeight: 500}}>
        Hint:
      </Typography>
      <Paper
        sx={{
          p: 2,
          bgcolor: 'info.50',
          border: '1px solid',
          borderColor: 'info.200',
          borderRadius: 1,
        }}
      >
        <MarkdownContentRenderer content={hint} />
      </Paper>
    </Box>
  );
}
